export interface Activity {
    action: Action;
    actor: ActivityActor;
    timestamp: Date;
}

export interface Action {
    type: ActionType;
    data: Edit | Comment | Mention;
}

export enum ActionType {
    Unknown,
    None,
    Edit,
    Comment,
    Mention
}

export interface ActivityActor {
    user: User;
    id: string;
}

export interface User {
    displayName: string;
    email: string;
    userPrincipalName: string;
    self?: Object;
}

export interface Comment {
    isReply: boolean;
    parentAuthor: ActivityActor;
    participants: Array<ActivityActor>;
}

export interface Mention {
    mentionees: Array<ActivityActor>;
}

export interface Edit { }
